<template>
  <ul class="v-dropdown" ref="dropdownMenu" :class="{right: align === 'right', compact: compact}">
    <li v-for="path in paths" :key="path">
      {{ path }}
      <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        style="position: absolute; top: 1px; right: 0;"
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
        <path d="M0 0h24v24H0z" fill="none"></path>
      </svg>

      <ul class="sub-menu v-dropdown">
        <a-select-dropdown-item
          v-for="(option, index) in optionsByPath('/' + path)"
          :key="option[optionKey] + index"
          :class="{highlight: index === typeAheadPointer, separator: option.separator, paddedLarge: option.level}"
          :isSelected="isSelected(option)"
          :isAboveLevel="checkAboveLevel(option.level)"
          :level="option.level || ''"
          :cohort="cohort"
          :optionTitle="option[optionLabel]"
          :multiple="multiple"
          @mousedown.native.prevent="select(option)"
        />
      </ul>
    </li>
    <a-select-dropdown-item
      v-for="(option, index) in optionsByPath('/')"
      :key="option[optionKey] + index"
      :class="{highlight: index === typeAheadPointer, separator: option.separator, paddedLarge: option.level}"
      :isSelected="isSelected(option)"
      :isAboveLevel="checkAboveLevel(option.level)"
      :level="option.level || ''"
      :cohort="cohort"
      :optionTitle="option[optionLabel]"
      :labelPrefix="option.labelPrefix"
      :multiple="multiple"
      @mousedown.native.prevent="select(option)"
    />
    <li v-if="!options || !options.length" class="inactive">No available options for the query</li>
  </ul>
</template>

<script>
import aSelectDropdownItem from './a-select-dropdown-item.vue'
import PointerScroll from '../../mixins/scroll.js'

export default {
  name: 'a-select-dropdown',
  components: {
    aSelectDropdownItem,
  },
  mixins: [PointerScroll],
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedOptions: {},
    typeAheadPointer: {
      type: Number,
      required: true,
    },
    optionLabel: {
      type: String,
      required: true,
    },
    optionKey: {
      type: String,
      required: true,
    },
    align: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: true,
    },
    compact: {
      type: Boolean,
      required: true,
    },
    cohort: {
      type: String,
      required: true,
    },
  },
  computed: {
    paths() {
      const filtered = this.options
        .filter(option => option.menuPath && option.menuPath !== '/')
        .map(option => option.menuPath.substr(1))
      return [...new Set(filtered)]
    },
  },
  methods: {
    optionsByPath(path) {
      return this.options.filter(option => {
        return (path === '/' && !option.menuPath) || option.menuPath === path
      })
    },
    select(option) {
      const isAboveLevel = this.checkAboveLevel(option.level)
      this.$emit('select', { option, isAboveLevel })
    },
    isSelected(option) {
      if (Array.isArray(this.selectedOptions)) {
        return !!this.selectedOptions.find(select => select[this.optionKey] === option[this.optionKey])
      }
      return !!this.selectedOptions
    },
    checkAboveLevel(level) {
      if (this.cohort === 'advanced') {
        return true
      }
      if (this.cohort === 'basic' && level !== 'advanced') {
        return true
      }
      return false
    },
  },
}
</script>

<style scoped>
.v-dropdown {
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  position: unset;
}
.v-dropdown svg {
  fill: rgba(0, 0, 0, 0.87);
}
.v-dropdown li {
  cursor: pointer;
  padding: 0 28px 0px 8px;
  position: relative;
  white-space: nowrap;
}
.large .v-dropdown li {
  padding: 4px 28px 4px 8px;
}
.v-dropdown .highlight {
  background-color: #e1e1e1;
}
.v-dropdown .separator {
  border-top: 1px solid #e1e1e1;
}
.v-dropdown .paddedLarge {
  padding-right: 10em;
}
.v-dropdown.compact {
  top: 0;
  left: 0;
}
.v-dropdown.right.compact {
  right: 0;
  left: auto;
}
.sub-menu {
  display: none;
  position: absolute;
  top: 5px;
  left: calc(100% - 20px);
}
.v-dropdown li:hover .sub-menu {
  display: block;
}
.v-dropdown .inactive {
  cursor: not-allowed;
}
.compact .sub-menu {
  top: 5px;
  right: 5px;
  left: auto;
}
</style>
